import React from 'react'
import { withStyles,withTheme } from '@material-ui/core/styles'

import AdapterLink from '../@react-fefmwk/links/modules/AdapterLink'
import ResetPasswordForm from '../@react-fefmwk/auth/modules/ResetPasswordForm'

import { NavTopTitle } from '../services/NavTopSchema'

import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const loginStyles = {
    cardContent: {
        paddingTop: 4,
        paddingBottom: 4,
        "&:last-child": {
            paddingBottom: 4
        }
    },
    cleanLink: {
        textDecoration: 'none',
        color: 'gray',
    },
}

class ResetPassword extends React.Component {
    render() {
        const theme = this.props.theme
        const defaultHomeUrl = theme.hasOwnProperty('homeUrl') ? theme.homeUrl : "/"
        const redirectTo = this.props.hasOwnProperty('redirectTo')
            ? this.props.redirectTo
            : defaultHomeUrl
        
        const { classes } = this.props

        return <React.Fragment>
            <Card>
                <Box bgcolor="secondary.500" color="white" component="div" width="100%">
                    <CardContent className={classes.cardContent}>
                        <Grid container direction="row"
                            spacing={0}
                            alignItems="center"
                            justify="flex-start"
                        >
                            <Grid item>
                                <img className="LogoImg" src="/images/logo-login.png" alt="Logo" style={{maxWidth:40}} />
                            </Grid>
                            <Grid item>
                                <Typography variant="h5" color="inherit" className="appTitle">
                                    {NavTopTitle}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Box>
                <CardContent>
                    <ResetPasswordForm redirectTo={redirectTo}
                        msgWelcome={(user) => <React.Fragment>
                            Ciao {user.user},<br />
                            inserisci la nuova password due volte.
                        </React.Fragment>}
                        msgAfterForgot="Password aggiornata. Torna al login per accedere"
                        onValidate={(values,errors) => {
                            const password = values.hasOwnProperty('password') ? values.password : ''             
                            if( password && password.length < 10 )
                                errors['password'] = "Password must have at least 10 characters"

                            return errors
                        }}
                        buttons={(formikProps) => <React.Fragment>
                            <Button color="primary" variant="contained" className={classes.resetBtn}
                                disabled={!formikProps.isValid}
                                type="submit"
                            >Reset</Button>
                        </React.Fragment>}
                    />
                    <Box mt={2}>
                        <Typography variant="caption" component={AdapterLink} to="/" className={classes.cleanLink}>
                            &laquo; Torna al login
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </React.Fragment>
    }
}

export default withStyles(loginStyles)(withTheme(ResetPassword))